<template>
  <RadioGroup
    v-model="model"
    class="radio-filter-group flex items-center flex-wrap gap-y-2"
  >
    <RadioGroupLabel class="radio-filter-group__label mr-2">
      <span class="block truncate">{{ label }}</span>
    </RadioGroupLabel>
    <div class="flex items-center flex-wrap gap-y-2">
      <RadioGroupOption v-slot="{ checked }" :value="''">
        <span
          class="radio-filter-group__option px-2 py-1 font-medium rounded-md cursor-pointer border border-transparent hover:border-gray-200 dark:hover:border-neutral-500"
          :class="{
            'bg-cardinal text-white': checked,
            'md:px-3 md:py-1': size !== 'normal',
          }"
          >All</span
        >
      </RadioGroupOption>
      <RadioGroupOption v-slot="{ checked }" :value="'upper'">
        <span
          class="radio-filter-group__option px-2 py-1 font-medium rounded-md cursor-pointer border border-transparent hover:border-gray-200 dark:hover:border-neutral-500"
          :class="{
            'bg-cardinal text-white': checked,
            'md:px-3 md:py-1': size !== 'normal',
          }"
          >Upper 1/3 D1</span
        >
      </RadioGroupOption>
      <RadioGroupOption v-slot="{ checked }" :value="'middle'">
        <span
          class="radio-filter-group__option px-2 py-1 font-medium rounded-md cursor-pointer border border-transparent hover:border-gray-200 dark:hover:border-neutral-500"
          :class="{
            'bg-cardinal text-white': checked,
            'md:px-3 md:py-1': size !== 'normal',
          }"
          >Middle 1/3 D1</span
        >
      </RadioGroupOption>
      <RadioGroupOption v-slot="{ checked }" :value="'lower'">
        <span
          class="radio-filter-group__option px-2 py-1 font-medium rounded-md cursor-pointer border border-transparent hover:border-gray-200 dark:hover:border-neutral-500"
          :class="{
            'bg-cardinal text-white': checked,
            'md:px-3 md:py-1': size !== 'normal',
          }"
          >Lower 1/3 D1</span
        >
      </RadioGroupOption>
    </div>
  </RadioGroup>
</template>

<script lang="ts" setup>
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from '@headlessui/vue';

const model = defineModel<null | 'upper' | 'lower' | 'middle'>();

export interface Props {
  size?: 'sm' | 'normal';
  label: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 'normal',
});
</script>
